import { render, staticRenderFns } from "./history-modal-table.component.vue?vue&type=template&id=72e55cf0&scoped=true&"
import script from "./history-modal-table.component.vue?vue&type=script&lang=ts&"
export * from "./history-modal-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./history-modal-table.component.vue?vue&type=style&index=0&id=72e55cf0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e55cf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
